/** WORKOUT SERVICES */
/** WORKOUT SERVICES */
/** WORKOUT SERVICES */


// CREATE A WORKOUT LOG
export async function createNewWorkoutLog(uId, token, workoutDate, workoutLog) {
  // return newly created ID if create is successful, or throws error.

  // build the REST API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/workouts/${uId}/${workoutDate}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(workoutLog),
  });
  const responseData = await response.json();
  // console.log('*** WorkoutServices > addNewWorkoutLog > responseData ***', responseData);

  // "err handling" - needs to be made real
  if (!response.ok) {
    throw new Error(response.message || 'Failed to add a new Workout Log');
  }
  return responseData;
}


// READ ALL WORKOUT LOGS (SHALLOW - just get the dates of the existing Workout Logs)
export async function getAllExistingWorkoutLogDates(uId, token) {
  // return an object of all Workout Logs, or null.

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/workouts/${uId}.json?auth=${token}&shallow=true`);
  const responseData = await response.json();
  // console.log(responseData);

  // err-handling
  if(!response.ok) {
    throw new Error(response.message || 'Failed to read all Workout Logs');
  }
  // return data
  return responseData || null;
}


// READ ONE WORKOUT
export async function getOneWorkoutLogFromDbase(uId, token, wDate) {
  // returns a Workout Log object, or throws error
  // console.log('*** WorkoutServices >> starting getOneWorkoutLogFromDbase(wDate) ***', wDate);
  
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/workouts/${uId}/${wDate}.json?auth=${token}`);
  const responseData = await response.json();

  if (!response.ok) {
    throw new Error(response.message || 'Failed to get one Workout Log');
  }

  return responseData || null;

}
















// UPDATE A WHATDO's OPTIONS
export async function updateOneWhatDo(uId, token, wdId, whatDo) {
  // returns the just-updated whatDo object, or throws error
  // console.log('*** starting updateOneWhatDo(uId, token, whatDo) ***', wdId, whatDo);

  // response
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/whatdos/${uId}/${wdId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(whatDo)
  });
  const responseData = await response.json();

  if (!response.ok) {
    // console.log(responseData);
    throw new Error(response.message || 'Failed to update a whatDo');
  } else {
    return responseData;
  }
}




// DELETE A WHATDO
export async function deleteOneWorkoutLog(uId, token, wId ) {
  // returns nothing
  // console.log('*** starting deleteOneWorkoutLog(uId, token, wId) ***', wId);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/workouts/${uId}/${wId}.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();

  if (!response.ok) {
    throw new Error(response.message || 'Failed to delete a Workout Log');
  } else {
    return responseData;
  }
}


